import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { ContactCard } from "./ContactCard";
import { SocialIcon } from "./SocialIcon";
import type { SocialMedia } from "./types";

interface SocialMediaCardProps {
  socialMedias: SocialMedia[];
}

/** 社交媒体卡片：遍历平台，按名称渲染本地图标并跳转（Web 端优先 link） */
export const SocialMediaCard = ({ socialMedias }: SocialMediaCardProps) => {
  return (
    <ContactCard title={<Trans>Social Media</Trans>}>
      <div className="flex w-full flex-wrap items-center justify-center gap-[16px]">
        {socialMedias.map(({ name, link, schemeUrl }) => {
          const href = link || schemeUrl || undefined;
          return (
            <a
              key={name}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={name}
              className={twMerge("flex size-[36px] items-center justify-center", !href && "pointer-events-none")}
            >
              <SocialIcon name={name} />
            </a>
          );
        })}
      </div>
    </ContactCard>
  );
};
